import React from "react";
import loadable from "@loadable/component";
import withLayout from "../../../components/desktop/layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
const CityEChallan = loadable(() => import("../../../components/desktop/city-e-challan"));
import withReducer from "../../../components/shared/with-reducer";
import injectable from "./injectable";

const CityEChallanContainer = () => {
    return (
        <ErrorHandler><CityEChallan /></ErrorHandler>
    );
};

export default withReducer(injectable)(() => ({}), dispatch => ({dispatch}))(
    withLayout(
        CityEChallanContainer,
        true,
        true,
        false,
        false
    )
);
